module.exports = __webpack_public_path__ + "img/credential-1.bda6f1e2.png";